import React from 'react';

interface NoDragWrapperProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Wrapper component that prevents drag events from being passed to parent elements.
 * Use this to wrap dropdown components that should not trigger row dragging in tables.
 */
export const NoDragWrapper: React.FC<NoDragWrapperProps> = ({ children, className = '' }) => {
  return (
    <div
      className={`${className}`}
      data-no-dnd="true"
      onClick={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onTouchStart={(e) => e.stopPropagation()}
      onDragStart={(e) => e.preventDefault()}
      draggable={false}
    >
      {children}
    </div>
  );
};

export default NoDragWrapper;
